// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"92d69124","227":"10e517ec","355":"38134aee","633":"c420f6f4","658":"608f7bda","686":"d8980854","725":"8a8d8805","787":"40901e99","799":"4b115588","822":"61be059a","838":"34fe319c","981":"4845bfc7"}[chunkId] + ".chunk.js";
};